import React from "react";
import { FiArrowRight, FiClock } from "react-icons/fi";

function ToolCard({ tool, onSelect }) {
  const IconComponent = tool.icon;
  const isComingSoon = tool.status === "coming-soon";

  return (
    <article 
      className={`tool-card ${isComingSoon ? "coming-soon" : "available"}`}
      tabIndex={0} 
      role="button" 
      aria-label={`${tool.title}: ${tool.description}`}
      onClick={onSelect}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") onSelect(); }}
    >
      <div className="tool-card-header">
        <div 
          className="tool-card-icon-wrapper" 
          style={{ backgroundColor: isComingSoon ? "rgba(161, 0, 255, 0.05)" : `${tool.color}12` }}
        >
          <IconComponent 
            className="tool-card-icon" 
            style={{ color: isComingSoon ? "#B388FF" : tool.color }} 
          />
        </div>
        {isComingSoon && (
          <span className="coming-soon-badge">
            <FiClock className="badge-icon" />
            Coming Soon
          </span>
        )}
      </div>
      
      <div className="tool-card-content">
        <h3 className="tool-card-title">{tool.title}</h3>
        <p className="tool-card-description">{tool.description}</p>
        
        {tool.features && (
          <div className="tool-card-features">
            {tool.features.map((feature, index) => (
              <span key={index} className="feature-tag">{feature}</span>
            ))}
          </div>
        )}
      </div>
      
      <div className="tool-card-footer">
        {isComingSoon ? (
          <span className="action-coming-soon">
            <FiClock className="action-icon" />
            <span>Notify Me</span>
          </span>
        ) : (
          <button 
            className="action-button" 
            onClick={(e) => { e.stopPropagation(); onSelect(); }} 
            aria-label={`Go to ${tool.title}`}
          >
            <span>Get Started</span>
            <FiArrowRight className="action-icon" />
          </button>
        )}
      </div>
    </article>
  );
}

export default ToolCard;